/**
 * Checks if a URL is a Google Cloud Storage URL
 * @param url - The URL to check
 * @returns true if the URL is a GCS URL, false otherwise
 */
const isGcsUrl = (url: string): boolean => {
  return url.includes('storage.googleapis.com');
};

export default isGcsUrl;
